import React from 'react';
import { TextInput } from '@patternfly/react-core';

export interface TimeInputProps {
  id: string;
  value: string;
  placeholder?: string;
  ariaLabel: string;
  onFocus?: () => void;
  onMouseUp?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const TimeInput: React.FC<TimeInputProps> = ({
  id,
  value,
  placeholder = 'HH:MM',
  ariaLabel,
  onFocus,
  onMouseUp,
  onKeyDown,
}) => (
  <TextInput
    type="text"
    id={id}
    value={value}
    onChange={() => {/* handled by onKeyDown */}}
    onFocus={onFocus}
    onMouseUp={onMouseUp}
    onKeyDown={onKeyDown}
    placeholder={placeholder}
    aria-label={ariaLabel}
  />
);
